<template>
  <div :class="'parent ' + size" v-show="isLoading">
    <div class="loading">
      <div :class="'spinner ' + type"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LD",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "normal",
    },
    type: {
      type: String,
      default: "white",
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less">
.parent {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &.small {
    .loading {
      display: flex;
      margin-right: 5px;
      margin-top: -4px;
    }
    .spinner {
      width: 28px;
      height: 28px;
    }
  }
}

.loading {
  display: inline-block;
  text-align: center;
}

.spinner {
  display: inline-block;
  width: 48px;
  height: 48px;
  animation: spin 1.2s linear infinite;
  background: url("../../assets/images/iconsV2/icon_loading.png");
  background-size: 100% 100%;
  &.black {
    background: url("../../assets/images/iconsV2/icon_loading_black.png");
    background-size: 100% 100%;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
